import { OrbitControls, PerspectiveCamera } from "@react-three/drei";
// import { extend, useThree, useFrame } from "@react-three/fiber";
// import * as THREE from "three";
import { useRef, useEffect } from "react";

export default function OrbitCam(Props) {
  const controlsRef = useRef();
  const camera = useRef();
  // const collisionBox = useRef();

  // const minDistance = 100;
  // const maxDistance = 150;

  return (
    <group>
      <PerspectiveCamera
        ref={camera}
        makeDefault
        //fov coming from camera
        fov={55}
        //coming from camera in max
        position={[-81, 328, -78]}
        zoom={1}
      />

      {/* <OrbitControls */}
      <OrbitControls
        ref={controlsRef}
        minDistance={300}
        maxDistance={400}
        enablePan={false}
        // enableZoom={true}
        enableZoom={false}
        minPolarAngle={0.5}
        maxPolarAngle={1.03}
        target={[0, -50, 0]}y
      />
    </group>
  );
}
